import { render, staticRenderFns } from "./FundraisingDetails.vue?vue&type=template&id=8aee583e&"
import script from "./FundraisingDetails.vue?vue&type=script&lang=js&"
export * from "./FundraisingDetails.vue?vue&type=script&lang=js&"
import style0 from "./FundraisingDetails.vue?vue&type=style&index=0&id=8aee583e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports